export const firstToUpper = (str: string) => {
  if (!Boolean(str)) { // check on empty string
    return str;
  }

  return str[0].toUpperCase() + str.substring(1);
};
